import { api } from './base';

import { MutationArg } from 'v2/types';
import { StreamerWheelModel } from 'v2/types/StreamerWheelModel';
import { SWRKeyValue } from 'v2/types/swr';

export const streamerWheelService = {
  getStreamerWheels(): Promise<StreamerWheelModel[]> {
    return api.get('v1/admin/streamer-wheel').json();
  },

  createStreamerWheel(_key: string, { arg }: MutationArg<Omit<StreamerWheelModel, 'id'>>): Promise<StreamerWheelModel> {
    return api.post('v1/admin/streamer-wheel', { json: arg }).json();
  },

  updateStreamerWheel(
    [_key, wheelId]: SWRKeyValue,
    { arg }: MutationArg<Omit<StreamerWheelModel, 'id'>>
  ): Promise<StreamerWheelModel> {
    return api.put(`v1/admin/streamer-wheel/${wheelId}`, { json: arg }).json();
  },

  deleteStreamerWheel([_key, wheelId]: SWRKeyValue): Promise<void> {
    return api.delete(`v1/admin/streamer-wheel/${wheelId}`).json();
  },

  setActiveStreamerWheel(
    [_key, wheelId]: SWRKeyValue,
    { arg: isActive }: MutationArg<boolean>
  ): Promise<StreamerWheelModel> {
    return api.patch(`v1/admin/streamer-wheel/${wheelId}/active`, { json: { isActive } }).json();
  },
};
